
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/portal",
      function () {
        return require("private-next-pages/portal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/portal"])
      });
    }
  